import { FormGroup } from '@angular/forms';

export function enableControls(form: FormGroup, controls: string[]): void {
  controls.forEach((controlName) => {
    const control = form.get(controlName);
    if (!control) {
      return;
    }
    control.enable();
    control.updateValueAndValidity();
  });
}
